import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

const CustomModal = ({ isOpen, onClose, content, title }) => {
  // Check if the content follows the " | " pattern

  const isListFormat = content?.includes(" | ");

  // Split content into an array if it's in list format
  const listItems = isListFormat ? content.split(" | ") : [];

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {isListFormat ? (
          <ul className="list-disc pl-5">
            {listItems.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        ) : (
          <p className="whitespace-pre-line" style={{ textAlign: "justify" }}>
            {content}
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
